// extracted by mini-css-extract-plugin
export default {"footerBg":"K-z","footerTopLinks":"L-z","footerFeedback":"M-z","footerSocial":"N-z","footerLegalLinks":"O-z","footerIconCards":"P-z","footerBotCopy":"Q-z"};